import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import { Button, Row, Table, Col } from "reactstrap";
import axios from "axios";
import { TableHeader } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoInventariosCostosResumen() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;

  const [totalTotal, setTotalTotal] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);

  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    showLoader();
    axios
      .get(`${URL_INVENTARIOS}CostosResumen`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const allInventarios = response.data || [];

        const dataFinal = allInventarios
          .sort((a, b) => (String(a.area) > String(b.area) ? 1 : -1))
          .map((a) => ({
            _id: a._id,
            cantidad: Number(a.cantidad) || 0,
            totalDinero: Number(a.totalDinero) || 0,
            area: a.area || "",
            idArea: a.idArea,
          }));

        setComments(dataFinal);
      })
      .catch((err) => {
        console.error("Error cargando CostosResumen:", err);
      })
      .finally(() => {
        hideLoader();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headers = [
    { name: "Area", field: "area", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Total Dinero", field: "totalDinero", sortable: true },
  ];

  // 1) Filtrar + ordenar (sin setState aquí)
  const filteredSorted = useMemo(() => {
    let arr = [...comments];

    if (search) {
      const s = search.toLowerCase();
      arr = arr.filter(
        (x) =>
          String(x.area).toLowerCase().includes(s) ||
          String(x.cantidad).includes(search) ||
          String(x.totalDinero).includes(search)
      );
    }

    // Sorting
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;

      arr.sort((a, b) => {
        const fa = a[sorting.field];
        const fb = b[sorting.field];

        // num
        if (sorting.field === "cantidad" || sorting.field === "totalDinero") {
          return reversed * ((Number(fa) || 0) - (Number(fb) || 0));
        }

        // string
        return reversed * String(fa ?? "").localeCompare(String(fb ?? ""));
      });
    }

    return arr;
  }, [comments, search, sorting]);

  // 2) Totales y totalItems (derivados)
  useEffect(() => {
    setTotalItems(filteredSorted.length);

    const TCan = filteredSorted.reduce((acc, x) => acc + (Number(x.cantidad) || 0), 0);
    const TDin = filteredSorted.reduce((acc, x) => acc + (Number(x.totalDinero) || 0), 0);

    setTotalTotal(TCan);
    setTotalTotalDinero(TDin);

    // opcional: si buscas, regresa a la página 1
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filteredSorted.length]); // (o usa [filteredSorted, search])

  // 3) Paginación final
  const commentsData = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredSorted.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredSorted, currentPage]);

  return (
    <>
      <Header />
      <br />
      <br />

{user?.inventarios_costos ? (
  <Row className="justify-content-center">
    <Col md={8} lg={6}>
      <div className="card p-3">
        <Row>
          <Col md={8}>
            <Button
              size="sm"
              href="/MenuAdmin"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Col>
        </Row>

        <h3 className="text-center">Inventarios Costos Resumen</h3>

        <Table size="sm" striped borderless className="table-responsive-xl">
          <TableHeader
            headers={headers}
            onSorting={(field, order) => setSorting({ field, order })}
          />
          <tbody>
            {commentsData.map((a) => (
              <tr key={a._id}>
                <td>{a.area}</td>
                <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(a.totalDinero)}
                </td>
              </tr>
            ))}

            <tr>
              <td className="negrita">TOTAL GENERAL</td>
              <td className="negrita">
                {new Intl.NumberFormat("en-US").format(totalTotal)}
              </td>
              <td className="negrita">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(totalTotalDinero)}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Col>
  </Row>
) : null}


      {loader}
    </>
  );
}

export default ListadoInventariosCostosResumen;
